import { Pipe, PipeTransform } from "@angular/core";
import { Port } from "../models/port";
import { RawEventData } from "../models/RawEventData";

@Pipe({name: 'unitStep'})
export class StepPipe implements PipeTransform{

    transform(raw: RawEventData[], port:Port, portType:number) : any{
        
        let base: any = {
            name: port.port_label,
            series: []
          };

        if(!raw){
            base.series.push({
                value:0,
                name: 'No Results'
            })

            return base;
        }

        raw.forEach(element => {


            base.series.push({
                value: element.evt_status, //pipe this value
                name: new Date(element.id.date) //ok
            })
        })
        return base;
    }
}

